export default __webpack_public_path__ + "static/media/plus_lynch_icon.bc8bdfe9.svg";